<template>
  <dialog-base
    :visible.sync="visible"
    title="Tạo ghi chú hàng loạt"
    size="sm"
    :use-panel="false"
    @cancel="handleClose"
  >
    <el-form
      ref="dataForm"
      :model="dataForm"
      :rules="formRules"
      label-position="top"
      class="sk-dialog-content"
    >
      <div class="sk-panel">
        <div class="sk-panel-head">
          <div class="sk-panel-icon"><i class="el-icon-edit-outline" /></div>
          <div>
            <p class="sk-panel-title">Tạo ghi chú hàng loạt</p>
            <p class="sk-panel-subtitle">Áp dụng cho {{ selectedCount }} phiếu thu đã chọn</p>
          </div>
        </div>

        <el-form-item label="Nội dung ghi chú" prop="note" class="sk-u-mt-12">
          <el-input
            v-model="dataForm.note"
            type="textarea"
            :rows="4"
            placeholder="Nhập nội dung ghi chú..."
            maxlength="500"
            show-word-limit
          />
        </el-form-item>
      </div>
    </el-form>

    <template #footer>
      <div class="sk-dialog__footer">
        <el-button class="btn-cancel" plain @click="handleClose">Hủy</el-button>
        <el-button class="btn-save" type="primary" :loading="loading" @click="handleSubmit">Lưu</el-button>
      </div>
    </template>
  </dialog-base>
</template>

<script>
import DialogBase from "@/components/DialogBase.vue";
import ManagingStudentInvoiceService from "@/services/tutition_v3/ManagingStudentInvoiceService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

function initDataForm() {
  return {
    note: "",
  };
}

export default {
  name: "BatchUpdateNoteDialog",
  components: { DialogBase },
  data() {
    return {
      visible: false,
      loading: false,
      selectedCount: 0,
      idxList: [],
      dataForm: initDataForm(),
      formRules: {
        note: [
          { required: true, message: "Nội dung ghi chú không được để trống", trigger: "blur" },
          { max: 500, message: "Ghi chú không được vượt quá 500 ký tự", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    open(idxList) {
      this.idxList = idxList || [];
      this.selectedCount = this.idxList.length;
      this.dataForm = initDataForm();
      this.visible = true;
      this.$nextTick(() => this.$refs.dataForm?.clearValidate());
    },

    handleSubmit() {
      this.$refs.dataForm.validate(async (valid) => {
        if (!valid) return;
        this.loading = true;
        try {
          const payload = {
            note: this.dataForm.note,
            idxList: this.idxList,
          };
          const response = await ManagingStudentInvoiceService.batchUpdateNote(payload);
          if (response?.data?.data === true || response?.data?.status === 200) {
            NotifyMessage.leftCornerNotificationSuccess("Tạo ghi chú hàng loạt thành công.");
            this.$emit("saved");
            this.handleClose();
          } else {
            throw new Error("Cập nhật thất bại.");
          }
        } catch (error) {
          console.error(error);
          NotifyMessage.leftCornerNotificationError(
            (error && error.response && error.response.data && error.response.data.message) ||
              "Tạo ghi chú hàng loạt thất bại."
          );
        } finally {
          this.loading = false;
        }
      });
    },

    handleClose() {
      this.visible = false;
      this.loading = false;
      this.$refs.dataForm?.resetFields();
      this.dataForm = initDataForm();
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/sk-dialog";
</style>
